module.exports = __webpack_public_path__ + "assets/card-icons.2dea4e12.svg";